import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

export const QuantitySelector = ({
  quantity,
  onUpdate,
  maxQuantity,
}: QuantitySelectorProps) => {
  const [displayValue, setDisplayValue] = useState<string | number>(quantity)
  useEffect(() => {
    setDisplayValue(quantity)
  }, [quantity])

  const qtyToShow = !maxQuantity || maxQuantity > 10 ? 10 : maxQuantity

  const numberOfOptions = [...Array(qtyToShow).keys()]

  const onSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setDisplayValue(e.target.value)
    onUpdate(+e.target.value)
  }

  return (
    <Container>
      <ArrowIconContainer>
        <span></span>
      </ArrowIconContainer>
      <Select
        value={displayValue}
        onChange={onSelectChange}
        disabled={numberOfOptions.length === 0}
      >
        {numberOfOptions.map((option, index) => (
          <option value={option + 1} key={`Option__${option}--${index}`}>
            {option + 1}
          </option>
        ))}
      </Select>
    </Container>
  )
}

type QuantitySelectorProps = {
  quantity: number
  onUpdate: (quantity: number) => void
  maxQuantity: number
  minQuantity: number
  canAddMore?: boolean
  canAddLess?: boolean
}

const Container = styled.div`
  padding-top: 0.2rem;
  position: relative;
  background: rgb(255, 255, 255);
  display: inline-block;
  min-width: 3.5rem;
  vertical-align: bottom;
  overflow: hidden;
  z-index: 0;
`
const ArrowIconContainer = styled.div.attrs({
  className: 'd-flex align-items-center justify-content-center',
})`
  position: absolute;
  height: 100%;
  top: 50%;
  left: 75%;
  transform: translate(-50%, -50%);
  pointer-events: none;

  & > span {
    display: block;
    width: 0.8rem;
    height: 0.8rem;
    border-bottom: 0.2rem solid ${({ theme }) => theme.palette.greyTitle};
    border-right: 0.2rem solid ${({ theme }) => theme.palette.greyTitle};
    transform: rotate(45deg);
  }
`

const Select = styled.select`
  height: 100%;
  width: 100%;
  min-height: inherit;
  font-size: 1.4rem;
  color: ${({ theme }) => theme.palette.greyTitle};
  background: none;
  border: 0px;
  border-radius: 0.2rem;
  appearance: none;

  &:focus {
    outline: none;
  }
`
